<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?'编辑管理员':'新增管理员'" :visible.sync="dialog" @close="unShowClick()" width="30%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="管理员名称" prop="name" :label-width="formLabelWidth" v-if="activeName == 'zh'">
					<el-input style="width: 100%;" v-model="addBody.name" placeholder="请输入1-30位管理员名称"></el-input>
				</el-form-item>
				<el-form-item label="登陆账号" :label-width="formLabelWidth" prop="uname">
					<el-input style="width: 100%;" v-model="addBody.uname" placeholder="请输入登陆账号"></el-input>
				</el-form-item>
				<el-form-item label="登陆密码" prop="password" :label-width="formLabelWidth">
					<el-input type="password" style="width: 100%;" v-model="addBody.password" placeholder="请输入登陆密码"></el-input>
				</el-form-item>
				<el-form-item label="角色" prop="role_uuid" :label-width="formLabelWidth">
					<el-select style="width: 100%;" v-model="addBody.role_uuid" placeholder="请选择角色">
						<el-option v-for="item in lmList" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="editUser('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getAdminRoleList,
		addAdminUser,
		updateAdminUser,
		getAdminUserDetail
	} from '@/api/auth'
	import ImageUpload from "@/components/ImageUpload"

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					role_uuid: '',
					name: '',
					uname: "",
					password: '',
					uuid: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					role_uuid: [{
						required: true,
						message: '请选择角色',
						trigger: 'blur'
					}, ],
					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}, ],
					uname: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}, ],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}, ],
				},
				weightList: [],
				weight: '',
				isEdit: false,
				lmList: [],
			}
		},
		mounted() {
			
		},
		methods: {
			async getAdminRoleList(){
				let postData = {
					page_size: 99,
					page_index: 1,
				};
				const {
					status,
					data
				} = await getAdminRoleList(postData);
				if (status !== 200) return;
				this.lmList = data.result.data;
			},
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				// if (!this.validatePassword(this.addBody.password)) {
				// 	return this.$message.error('密码8位数以上，包含数字、大小写字母、特殊符号任意两种组合')
				// }
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().editUser()
						} else {
							this.network().addAdminUser()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					addAdminUser: async () => {
						const {
							status,
							data
						} = await addAdminUser({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					editUser: async () => {
						const {
							status
						} = await updateAdminUser({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getAdminUserDetail: async (uuid) => {
						const {
							data,
							status
						} = await getAdminUserDetail({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				if (val.uuid) {
					this.isEdit = true;
					this.network().getAdminUserDetail(val.uuid)
				} else {
					this.isEdit = false
					this.addBody.role_uuid = ''
					this.addBody.name = ''
					this.addBody.uname = ''
					this.addBody.password = ''
					this.addBody.uuid = ''
				}
				this.getAdminRoleList()
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>